import update from 'immutability-helper';

import useCheckoutState from './useCheckoutState';

export default function useCheckoutTicketFormHelpers() {
  const { setForm, hasFocusedCheckoutRef } = useCheckoutState();

  function setTicketType(ticketGroupId, ticketTypeId, quantity = 1) {
    hasFocusedCheckoutRef.current = true;

    setForm(form => {
      // Check if the ticketType with the ticketTypeId already exists
      const ticketGroupIndex = form.ticketGroups[ticketGroupId]?.findIndex(
        t => t.ticketTypeId === ticketTypeId,
      );

      let newForm;

      const ticketTypeExists = ticketGroupIndex > -1;

      if (ticketTypeExists) {
        // ticketType with ticketTypeId exists, update its quantity
        newForm = update(form, {
          ticketGroups: {
            [ticketGroupId]: {
              [ticketGroupIndex]: {
                quantity: {
                  $set: quantity,
                },
              },
            },
          },
        });
      } else {
        // ticketType with ticketTypeId does not exist, add new entry
        newForm = update(form, {
          ticketGroups: {
            [ticketGroupId]: {
              $push: [{ ticketTypeId: ticketTypeId, quantity: quantity }],
            },
          },
        });
      }

      return newForm;
    });
  }

  function unsetTicketType(ticketGroupId, ticketTypeId) {
    hasFocusedCheckoutRef.current = true;

    setForm(form => {
      const ticketGroupIndex = form.ticketGroups[ticketGroupId]?.findIndex(
        t => t.ticketTypeId === ticketTypeId,
      );

      if (ticketGroupIndex === -1) return form;

      // unset means setting quantity to 0
      return update(form, {
        ticketGroups: {
          [ticketGroupId]: {
            [ticketGroupIndex]: {
              quantity: {
                $set: 0,
              },
            },
          },
        },
      });
    });
  }

  return { setTicketType, unsetTicketType };
}
